import { useState, useCallback } from 'react';

export interface UsePictureSelectionReturn {
  selectedPictureIds: Set<string>;
  togglePictureSelection: (pictureId: string, event?: React.MouseEvent) => void;
  selectAll: (pictureIds: string[]) => void;
  clearSelection: () => void;
  isSelectedPictureAlreadyCover: () => boolean;
}

export const usePictureSelection = (
  vehiclePictures: Array<{ id: string; is_cover: boolean }>
): UsePictureSelectionReturn => {
  const [selectedPictureIds, setSelectedPictureIds] = useState<Set<string>>(new Set());

  const togglePictureSelection = useCallback((pictureId: string, event?: React.MouseEvent) => {
    if (event) {
      event.stopPropagation();
    }
    setSelectedPictureIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(pictureId)) {
        newSet.delete(pictureId);
      } else {
        newSet.add(pictureId);
      }
      return newSet;
    });
  }, []);

  const selectAll = useCallback((pictureIds: string[]) => {
    setSelectedPictureIds(prev => {
      const newSet = new Set(prev);
      pictureIds.forEach(id => newSet.add(id));
      return newSet;
    });
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedPictureIds(new Set());
  }, []);

  const isSelectedPictureAlreadyCover = useCallback(() => {
    if (selectedPictureIds.size !== 1) {
      return false;
    }
    const [selectedId] = Array.from(selectedPictureIds);
    const selectedPicture = vehiclePictures.find(pic => pic.id === selectedId);
    return selectedPicture?.is_cover || false;
  }, [selectedPictureIds, vehiclePictures]);

  return {
    selectedPictureIds,
    togglePictureSelection,
    selectAll,
    clearSelection,
    isSelectedPictureAlreadyCover,
  };
};
